/* eslint-disable */
import { makeStyles } from '@mui/styles'
import theme from '../../../../theme'

export const useStyles = makeStyles(() => ({
	footer: {
		[theme.breakpoints.up('tablet')]: {
			display: 'grid',
			gridTemplateColumns: '1fr 34.41%',
		},

		[theme.breakpoints.up('desktop')]: {
			paddingLeft: 77,
		},

		'& > div': {
			display: 'block',
			[theme.breakpoints.up('tablet')]: {
				display: 'flex'
			}
		}
	},
	footerInnerClassses: {
		borderTop: '1px solid var(--line) !important',
		[theme.breakpoints.up('tablet')]: {
			marginLeft: 0,
			borderLeft: '0'
		},
		[theme.breakpoints.up('desktop')]: {
			marginLeft: 0
		},
	},
	navigation: {
		borderLeft: '0 !important',
		marginLeft: '0 !important',
		[theme.breakpoints.up('tablet')]: {
			display: 'grid',
			gridTemplateColumns: '1fr 50%',
		},
		[theme.breakpoints.up('desktop')]: {
			marginLeft: '0 !important',
			paddingLeft: 0,
			gridTemplateColumns: '1fr 31.95%',

			'& > div': {
				borderLeft: '1px solid var(--line)'
			}
		},
	},
	services: {
		[theme.breakpoints.up('desktop')]: {
			borderLeft: '1px solid var(--line)',
			paddingLeft: '71px !important',
		}
	},
	copyright: {
		[theme.breakpoints.up('desktop')]: {
			paddingLeft: 77,
			borderRight: '0px !important',
			'& > div': {
				borderLeft: '1px solid var(--line)',
				paddingLeft: 71,
			}
		}
	},
	// 185px matches the left-rail width used on the ACT and TEAM pages.
	techWrapper: {
		[theme.breakpoints.up('laptop')]: {
			gridTemplateColumns: '185px 1fr'
		},
	},
	footerWrapper: {
		top: 40,
		[theme.breakpoints.up('tablet')]: {
			top: 133,
		},
		[theme.breakpoints.up('laptop')]: {
			top: 0,
			marginLeft: '185px',
			marginRight: '0',
			maxWidth: 1155,
			borderLeft: '0px !important',
		},
	},
	// Aligns the footer nav strip with the tech-stack content column.
	// 1px less than the content offset to absorb the footer's own left border.
	footerNav: {
		[theme.breakpoints.up('laptop')]: {
			marginLeft: '184px',
			maxWidth: '1155px !important',
		},
	}
}))